import { useState } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

function Apply() {
  const [form, setForm] = useState({ name: "", email: "", course: "", message: "" });
  const [resume, setResume] = useState(null);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.course) {
      setMsg("❌ Please fill all required fields!");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("course", form.course);
      formData.append("message", form.message);
      if (resume) formData.append("resume", resume);

      const res = await fetch(`${API}/api/apply`, { method: "POST", body: formData });
      const data = await res.json();
      setMsg(data.message ? "✅ " + data.message : "❌ " + data.error);
      if (data.message) {
        setForm({ name: "", email: "", course: "", message: "" });
        setResume(null);
      }
    } catch {
      setMsg("❌ Server error! Please try again.");
    }
    setLoading(false);
  };

  const inp = {
    width: "100%", padding: "12px 14px", marginBottom: "12px",
    border: "1.5px solid #e5e7eb", borderRadius: "8px",
    fontFamily: "'Inter',sans-serif", fontSize: "14px", color: "#1a1a1a",
    boxSizing: "border-box",
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center",
      alignItems: "center", background: "#f8f9fa", paddingTop: "80px", paddingBottom: "40px" }}>
      <div style={{ background: "white", border: "1px solid #e5e7eb", padding: "40px 36px",
        borderRadius: "16px", width: "100%", maxWidth: "500px", textAlign: "center",
        margin: "20px", boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>

        <div style={{ fontSize: "36px", marginBottom: "12px" }}>🚀</div>
        <h2 style={{ fontFamily: "'Poppins',sans-serif", fontSize: "24px", fontWeight: "800",
          color: "#1a1a1a", marginBottom: "6px" }}>Apply for Internship</h2>
        <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "28px" }}>
          We will reach out within 24-48 hours!
        </p>

        <input style={inp} type="text" placeholder="Full Name *" value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input style={inp} type="email" placeholder="Email Address *" value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })} />

        <select style={{ ...inp, color: form.course ? "#1a1a1a" : "#6b7280" }}
          value={form.course} onChange={(e) => setForm({ ...form, course: e.target.value })}>
          <option value="">Select Course Interest *</option>
          {["Web Development","UI/UX Design","Cyber Security","Data Science",
            "Cloud Computing","Artificial Intelligence","Blockchain","Digital Marketing"]
            .map((c) => <option key={c} value={c}>{c}</option>)}
        </select>

        <textarea style={{ ...inp, height: "100px", resize: "none" }}
          placeholder="Why do you want to join? (optional)"
          value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />

        <div style={{ marginBottom: "20px", textAlign: "left" }}>
          <label style={{ fontSize: "13px", color: "#374151", fontWeight: "600",
            display: "block", marginBottom: "6px" }}>Resume Upload (PDF/DOC, optional)</label>
          <input type="file" accept=".pdf,.doc,.docx"
            onChange={(e) => setResume(e.target.files[0])}
            style={{ ...inp, marginBottom: 0, padding: "9px 12px", background: "#f9fafb", cursor: "pointer" }} />
          {resume && <p style={{ fontSize: "12px", color: "#16a34a", marginTop: "4px" }}>Selected: {resume.name}</p>}
        </div>

        <button onClick={handleSubmit} disabled={loading}
          style={{ width: "100%", padding: "13px", background: "#0056D2", color: "white",
            border: "none", borderRadius: "8px", fontWeight: "700", fontSize: "15px",
            cursor: "pointer", fontFamily: "'Inter',sans-serif" }}>
          {loading ? "Submitting..." : "Submit Application"}
        </button>

        {msg && (
          <div style={{ marginTop: "16px", padding: "12px", borderRadius: "8px",
            background: msg.includes("✅") ? "#f0fdf4" : "#fef2f2",
            color: msg.includes("✅") ? "#16a34a" : "#dc2626", fontSize: "14px" }}>
            {msg}
          </div>
        )}
      </div>
    </div>
  );
}
export default Apply;
